import Cookies from 'js-cookie'

export const CookieSetting = {
  token: 'hai_nan_le_cheng_mobile_token',
  openId: 'hai_nan_le_cheng_mobile_openId',
  headImg: 'hai_nan_le_cheng_mobile_headImg',
  nickName: 'hai_nan_le_cheng_mobile_nickname',
  mobilePhone: 'hai_nan_le_cheng_mobile_mobile_phone',
  isSubscribe: 'hai_nan_le_cheng_mobile_is_subscribe',
  expires: process.env.NODE_ENV === 'development' ? 60 : 10 // cookie存留时间60天， 1个小时应为 60/1440 提交到测试时，保留0.1天
}
/**
 * 绑定、获取token时要带的参数
 * 公众号id
 * */
export const AppCode =
  process.env.VUE_APP_BUILD_TARGET === 'prod'
    ? 'wx6392230c265135b6'
    : 'wxe47aee2b50062827'
// export const AppCode = 'wxa8bd3198738586b3'

/**
 * 用户信息 cookie 操作
 * */
export const SetGetAuthInfo = {
  setInfo(obj = {}) {
    if (obj.token) {
      Cookies.set(CookieSetting.token, obj.token, {
        expires: CookieSetting.expires
      })
    }
    if (obj.openId) {
      Cookies.set(CookieSetting.openId, obj.openId, {
        expires: CookieSetting.expires
      })
    }
    if (obj.headImg) {
      Cookies.set(CookieSetting.headImg, obj.headImg, {
        expires: CookieSetting.expires
      })
    }
    if (obj.nickName) {
      Cookies.set(CookieSetting.nickName, obj.nickName, {
        expires: CookieSetting.expires
      })
    }
    if (obj.userAlias) {
      Cookies.set(CookieSetting.nickName, obj.userAlias, {
        expires: CookieSetting.expires
      })
    }
    if (obj.mobilePhone) {
      Cookies.set(CookieSetting.mobilePhone, obj.mobilePhone, {
        expires: CookieSetting.expires
      })
    }
    if (obj.isSubscribe) {
      Cookies.set(CookieSetting.isSubscribe, obj.isSubscribe, {
        expires: CookieSetting.expires
      })
    }
  },
  getInfo() {
    return {
      token: Cookies.get(CookieSetting.token) || '',
      openId: Cookies.get(CookieSetting.openId) || '',
      headImg: Cookies.get(CookieSetting.headImg) || '',
      nickName: Cookies.get(CookieSetting.nickName) || '',
      mobilePhone: Cookies.get(CookieSetting.mobilePhone) || '',
      isSubscribe: Cookies.get(CookieSetting.isSubscribe) || ''
    }
  },
  removeInfo() {
    Cookies.remove(CookieSetting.token)
    Cookies.remove(CookieSetting.openId)
    Cookies.remove(CookieSetting.headImg)
    Cookies.remove(CookieSetting.nickName)
    Cookies.remove(CookieSetting.mobilePhone)
    Cookies.remove(CookieSetting.isSubscribe)
  }
}

/**
 * 是否进行过授权判断
 * */
export const HasAuthed = {
  key: 'haiNanLeChengAuthed',
  yes: 'yes'
}
